




























import { DataParse } from "@wj/common";
import { Vue, Component } from "vue-property-decorator";
import { addResumeReq } from "@/common/class/h5/forgetPassWord/index";
import {
  getSmsCode,
} from "@/api/h5/index";
import {
  forgetPWDsubmit,
} from "@/api/h5/forgetPassword/index";
import {
  Cell,
  Form,
  Field,
  Button,
  Loading,
  Popup,
  Icon,
  Picker,
  Toast,
} from "vant";

@Component({
  components: {
    [Cell.name]: Cell,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [Loading.name]: Loading,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
  },
})
export default class empowermentQueryComponent extends Vue {
  loading = false;
  addResumeReq = new addResumeReq();
  showPicker = false;
  showMajorPicker = false;
  showEducationPicker = false;
  showJobPicker = false;
  value = "";
  educationList: any = [];
  majorList: any = [];
  jobList: any = [];
  showJob = false;
  created() {
    if (this.$route.query.id) {
      /*     this.addResumeReq.itineraryId = this.$route.query.id; */
      this.showJob = true;
    } else {
      this.showJob = false;
    }

  }
  mounted() {}
  goBack() {
    this.$router.push("personal");
  }
  // 发送验证码
  sendCaptcha() {
    if (this.addResumeReq.phone) {
      getSmsCode({ phone: this.addResumeReq.phone })
        .then((res) => {
          const { success, data, message } = res;
          if (success) {
            Toast.success(message);
          }
        })
        .finally(() => {});
    } else {
      Toast("请先填写手机号！");
    }
  }
  onSubmit(value: any) {
     if(this.addResumeReq.newPassword == this.addResumeReq.passwordAgain){
      this.loading = true;
    forgetPWDsubmit(this.addResumeReq)
      .then((res) => {
        const { data, message, success } = res;
        if (success) {
          Toast.success("修改成功！");
          setTimeout(() => {
               this.$router.push({
              path: "/login",
            });
          },1000);
        }
      })
      .finally(() => {
        this.loading = false;
      });
    }else{
     Toast.success("两次密码不一致！");
    }
  
  }
  onFailed(errorInfo: any) {
    if (errorInfo.errors.length > 0) {
      Toast("请填写完整星号内容！");
    }
  }
}
